import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var AutomationFilled = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "24",
    height: "24",
    viewBox: "1 1 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M12 2C11.4696 2 10.9609 2.21071 10.5858 2.58579C10.2107 2.96086 10 3.46957 10 4C10.0003 4.35081 10.0928 4.69537 10.2683 4.9991C10.4439 5.30284 10.6962 5.55507 11 5.73047V8H8C5.794 8 4 9.794 4 12V16H2V18H4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V18H22V16H20V12C20 9.794 18.206 8 16 8H13V5.72852C13.3035 5.55328 13.5557 5.30136 13.7312 4.998C13.9067 4.69463 13.9994 4.35047 14 4C14 3.46957 13.7893 2.96086 13.4142 2.58579C13.0391 2.21071 12.5304 2 12 2ZM8.5 12C9.328 12 10 12.672 10 13.5C10 14.328 9.328 15 8.5 15C7.672 15 7 14.328 7 13.5C7 12.672 7.672 12 8.5 12ZM15.5 12C16.328 12 17 12.672 17 13.5C17 14.328 16.328 15 15.5 15C14.672 15 14 14.328 14 13.5C14 12.672 14.672 12 15.5 12ZM9 18H15V20H9V18Z",
    fill: fill
  }));
};
export { AutomationFilled as default };
//# sourceMappingURL=AutomationFilled.js.map
